import request from '@/utils/request';
import { obj2query } from '@/utils'

export function getMainBlacklist() { 
  return request({
    url: `/api/firewall/blacklist/main`,
    method: "get"
  })
}

export function createMainBlacklist(data) { 
  return request({
    url: `/api/firewall/blacklist/main`,
    method: "post",
    data: data
  })
}

export function getMainBlacklistByUID(uid) { 
  return request({
    url: `/api/firewall/blacklist/main/${uid}`,
    method: "get"
  })
}

export function putMainBlacklist(uid, data) {
  return request({
    url: `/api/firewall/blacklist/main/${uid}`,
    method: "put",
    data: data
  })
}
 
export function deleteMainBlacklist(uid) { 
  return request({
    url: `/api/firewall/blacklist/main/${uid}`,
    method: "delete"
  })
}

export function searchCustomBlacklist(data) {
  return request({
    url: '/api/firewall/blacklist/custom',
    method: 'post',
    data
  });
}

export function getCustomBlacklist(plusuid) {
  return request({
    url: `/api/firewall/blacklist/custom/${plusuid}`,
    method: 'get'
  });
}

export function getCustomProjectBlacklist(query, projectuid) {
  return request({
    url: `/api/firewall/blacklist/custom/${projectuid}/lists${obj2query(query)}`,
    method: 'get'
  });
}

export function createCustomBlacklist(plusuid, data) {
  return request({
    url: `/api/firewall/blacklist/custom/${plusuid}`,
    method: 'post',
    data
  });
}

export function getCustomBlacklistByUID(plusuid, uid) { 
  return request({
    url: `/api/firewall/blacklist/custom/${plusuid}/${uid}`,
    method: 'get'
  });
}

export function putCustomBlacklistByUID(plusuid, uid, data) {
  return request({
    url: `/api/firewall/blacklist/custom/${plusuid}/${uid}`,
    method: 'put',
    data
  });
}

export function deleteCustomBlacklistByUID(plusuid, uid) { 
  return request({
    url: `/api/firewall/blacklist/custom/${plusuid}/${uid}`,
    method: 'delete'
  });
}